<!--
  @component
  Generates HTML text labels for a nested data structure. It places the label near the y-value of the highest x-valued data point. This is useful for labeling the final point in a multi-series line chart, for example. It expects your data to be an array of objects where each has `values` field that is an array of data objects. It uses the `z` field accessor to pull the text label.
 -->
<script>
	import { getContext } from "svelte";
	import { max } from "d3-array";
	import { draw, fade } from "svelte/transition";
	import { quintOut } from "svelte/easing";
	import arrow from "../../icons/arrow.svg";
	import participantsIcon from "../../icons/participants.svg";
	import PointAnnotation from './PointAnnotation.svelte'

	const { data, yGet, zGet, xGet, xScale, yScale, xDomain, yDomain } = getContext("LayerCake");

	export let lineDrawDuration;
	export let renderedLines;
</script>

{#each $data as group (group.id || group.topic)}
	{#if !!renderedLines[group.id || group.topic]}
		{#if group.settings.pointAnnotations}
			{#each group.settings.pointAnnotations as annotation}
				<PointAnnotation {...annotation} {lineDrawDuration} {renderedLines} id={group.id || group.topic}/>
			{/each}
		{/if}
	{/if}
{/each}

<style lang="scss">
	$labelOffsetMobile: 0;
	$labelOffset: 50px;

	.Annotation {
		&__label-container,
		&__arrow-container {
			position: absolute;
		}

		&__arrow-container {
			transform: translate(-100%, -100%);
		}

		&__label-container {
			transform: translate(-100%, -50%);
		}

		&__label {
			// box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);
			padding: 5px;
			transform: translate(-$labelOffset, -$labelOffset);

			@media (max-width: $breakpoint-mobile-l) {
				transform: translate(-$labelOffsetMobile, -$labelOffsetMobile);
			}

			&__secondary,
			&__main {
				display: block;
				text-align: left;
				text-shadow: 0px 0px 10px #211c46;
				font-size: 11px;
				font-style: normal;
				font-weight: 400;
				line-height: 115%;
				// white-space: nowrap;
				// border: 2px solid #211C46;
			}

			&__secondary {
				color: #838aa4;
				line-height: 1.8;
				white-space: nowrap;
			}

			&__main {
				font-weight: $bold;
				color: #bbc9d9;

				span {
					display: block;
					white-space: nowrap;
				}
			}
		}

		&__arrow {
			width: $labelOffset;
			height: $labelOffset;
			transform: rotate(0deg) scaleX(-1);

			@media (max-width: $breakpoint-mobile-l) {
				width: 0;
				height: 0;
			}
		}
	}

	.with-icon {
		display: inline-flex;
		align-items: center;

		img {
			height: 14px;
			transform: translateY(-2px);
		}
	}
</style>
